<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="12">
            <b-row class="pb-1">
              <b-col cols="12">
                <h4>Danh sách Email</h4>
              </b-col>
            </b-row>
            <b-row class="pb-1">
              <b-col class="text-left" cols="6">
                <b-button class="btn-sm mr-50" variant="primary" @click="New()">
                  <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
                  Thêm mới
                </b-button>
              </b-col>
              <b-col cols="6">
                <b-input-group>
                  <b-form-input v-model="searchQuery" placeholder="Tìm kiếm " v-on:keydown.enter="quickSearch"/>
                  <b-input-group-append is-text role="button" @click="quickSearch">
                    <feather-icon icon="SearchIcon"/>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :line-numbers="true" :rows="items"
                                :select-options="{ enabled: true }" :totalRows="totalRecords"
                                mode="remote"
                                @on-page-change="onPageChange" @on-sort-change="onSortChange"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange">
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Action -->
                    <span v-if="props.column.field === 'action'">
                      <span>
                        <b-button class="btn-icon" size="sm" variant="primary" @click="Edit(props.row, props.row.id)">
                          <feather-icon icon="Edit2Icon"/>
                        </b-button>
                        <b-button class="btn-icon" size="sm" style="margin-left: 6px" variant="danger"
                                  @click="DeleteItem(props.row, props.row.id)">
                          <feather-icon icon="TrashIcon"/>
                        </b-button>
                      </span>
                    </span>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal id="modal-edit" :title="getTitle()" size="xl" @ok="handleOk">
      <form ref="form">
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label>Email <span class='text-danger'>*</span></label>
              <b-form-input v-model="currentItem.email" :state="validateState('email')" placeholder="Nhập email" required
                            type="email"/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Mô tả danh mục">
              <b-form-textarea v-model="currentItem.description" k-max-length="500" max-rows="20"
                               placeholder="Mô tả danh mục" rows="8"/>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>

  </div>
</template>

<script>

import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
import {required} from "@validations";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BFormDatepicker,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BFormCheckbox,
  BFormGroup,
  VBTooltip,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";
import {stringToDate} from "@/@core/utils/utils";
import {getuserName} from '@/@core/utils/utils';


export default {
  name: "adminTopic",
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BFormTextarea,
    BInputGroup, BInputGroupAppend
  },
  methods: {
    validateState() {
      if (!this.isSubmit) return null;
      if (!this.currentItem.email || !this.validateEmail(this.currentItem.email)) return false;
      else return true;
      return null;
    },
    validateEmail(email) {
      if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(email)) {
        return true;
      } else {
        return false;
      }
    },
    getTitle() {
      if (this.editMode) {
        return "Cập nhật email ";
      } else {
        return "Thêm mới email ";
      }
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadItems();
    },


    loadItems() {
      this.loading(true);
      try {
        useJwt
            .get("portal/emailconfig", {
              columnFilters: {},
            })
            .then((response) => {
              this.items = response.data.result;
              this.totalRecords = response.data.totalRecords;
              this.isLoading = false;
            });
      } catch {
        this.loading(false);
      }
    },

    New() {
      this.currentItem = {};
      this.editMode = false;
      this.modal_title = "Thêm mới email ";
      this.$bvModal.show("modal-edit");
    },

    async Edit(item) {
      this.currentItem = item;
      this.editMode = true;
      this.modal_title = "Cập nhật email";
      this.$bvModal.show("modal-edit");
    },

    async DeleteItem(item, index, button) {
      this.currentItem = item;
      const url = `portal/emailconfig/${item.id}`;
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu email",
          {title: "Please Confirm", size: "sm"}
      );
      if (resModal) {
        try {
          this.loading(true);
          let res = await useJwt.delete(url);
          if (res.data.code == 200) {
            this.loadCategories();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xoá email thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          }
          this.loading(false);
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xoá email ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },


    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      const userName = getuserName();
      this.isSubmit = true;
      const bIsValid = await this.isValid(this.currentItem);
      if (!bIsValid) {
        return;
      }

      if (this.editMode) {
        const url = `portal/emailconfig/${this.currentItem.id}`;

        const updateParams = {
          id: this.currentItem.id,
          email: this.currentItem.email,
          description: this.currentItem.description,
          updated_at: userName,
          created_at: userName
        };
        try {
          this.loading(true);
          const res = await useJwt.put(url, updateParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.isSubmit = false;
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.$bvModal.hide("modal-edit");
            return;
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi cập nhật email ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return
        }
      }
      try {
        const createParams = {
          id: 0,
          email: this.currentItem.email,
          description: this.currentItem.description,
          updated_at: userName,
          created_at: userName
        };
        this.loading(true);
        const res = await useJwt.post("portal/emailconfig", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.isSubmit = false;
          this.loadItems();
          this.$bvModal.hide("modal-edit");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới email thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      } catch (error) {
        this.loading(false);
        // this.$bvModal.hide("modal-edit");
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới email ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },

    async isValid(item) {
      if (!item.email) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Email không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }

      return true;
    },
    async loadCategories() {
      try {
        this.loading(true);
        useJwt.get("portal/emailconfig?filter=" + this.searchQuery).then((response) => {
          var result = response.data;
          if (result.code == 200) {
            this.items = result.result;
            this.totalRecords = result.totalRecords;
            this.categoriesSelect = [];
            this.items.forEach(item => {
              this.categoriesSelect.push({'id': item.id, 'text': item.name});
            });
          }
          this.loading(false);
        });
      } catch {
        this.loading(false);
      }

    },
    async quickSearch() {
      this.loadCategories();
    },

    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    }
  },

  mounted() {
    this.loadCategories();
    this.isSubmit = false;
  },
  data() {
    return {
      isLoading: false,
      isSubmit: false,
      totalRecords: 0,
      totalRecordSubs: 0,
      items: [],

      editMode: false,
      totalItem: 0,
      searchQuery: "",
      currentItem: {},
      options: {
        fields: [
          {field: "action", label: "Cài đặt", width: "120px"},
          {
            field: "email",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Email",
            required: true,
            disabled: true,
          },
          {
            field: "description",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Mô tả",
            required: true,
            disabled: true,
          },
          {
            field: "created_date",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Ngày tạo",
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss',
            dateOutputFormat: 'dd/MM/yyyy HH:mm:ss',
            disabled: true
          },
          {
            field: "created_at",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Người tạo",
            required: true,
            disabled: true,
          }
        ]
      },
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
select[readonly].select2 + .select2-container {
  pointer-events: none;
  touch-action: none;

  .select2-selection {
    background: #eee;
    box-shadow: none;
  }

  .select2-selection__arrow,
  .select2-selection__clear {
    display: none;
  }
}

table.vgt-table td {
  min-width: 100px;
}
</style>
